<template>
  <div class="tab-content partner-list-page">
    <div class="pagenamPT">
      <h3 class="pagename2">{{ $t('front.common.allPartner') }}</h3>
    </div>
    <div class="partnerTop">
      <div></div>
        <date-filter-Pt :startDate="infoDate.startDate"
                        :endDate="infoDate.endDate"
                        @update="updateInfoDate"
                        @search="getMyPartnerList" />
      </div>
      <!-- 모바일 슬라이드 트리 -->
      <div class="partnerTreeMobileBtn" @click="partnerTreeOpen = !partnerTreeOpen">
        전체 파트너 목록 보기
      </div>

      <div class="partnerTreeDropdown" v-show="partnerTreeOpen">
        <PartnerHierarchy @onClickMemId="onClickPartnerTree"></PartnerHierarchy>
      </div>

      <div class="strTableWrap">
        <!-- PC용 트리 -->
        <div class="partnerTreePc">
          <PartnerHierarchy @onClickMemId="getMyPartnerList"></PartnerHierarchy>
        </div>
        <div class="w100">
          <div class="strTablescr">
            <div class="partnerInfo">
              <h4 class="title">※ {{ $t('front.common.getPartner') }}</h4>
              <div class="infoView" v-if="partnerInfo">
                <ul>
                  <li>{{ $t('front.common.information') }}</li>
                  <li>
                    <em>{{ $t('front.board.type') }}</em>
                    <span>{{partnerInfo.partnerLevelName}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.common.connectID') }} / {{ $t('front.common.nickName') }}</em>
                    <span>{{partnerInfo.memId}} / {{partnerInfo.memNick}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.nav3') }} / {{ $t('front.common.haveRolling') }}</em>
                    <span>{{thousand(partnerInfo.cashAmt || 0)}} / {{thousand(partnerInfo.pointAmt || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.common.tel') }}</em>
                    <span class="number">
                      <input type="text" v-model="partnerInfo.memPhone"/>
                      <a class="btnp" @click="onChangePhone(partnerInfo.memId, partnerInfo.memPhone)">{{ $t('front.common.changeTo') }}</a>
                    </span>
                  </li>
                  <li class="empty-info">
                    <!-- <em></em>
                    <span></span> -->
                  </li>
                  <li class="empty-info">
                    <!-- <em></em>
                    <span></span> -->
                  </li>
                </ul>
                <ul>
                  <li>{{ $t('front.stributor.roll') }} & {{ $t('front.stributor.lose') }}</li>
                  <li>
                    <em>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.casino') }})</em>
                    <span>{{partnerInfo.casinoRate}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.slot') }})</em>
                    <span>{{partnerInfo.slotRate}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.sport') }})</em>
                    <span>{{partnerInfo.sportRate}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.casino') }})</em>
                    <span>{{partnerInfo.casinoLosing}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.slot') }})</em>
                    <span>{{partnerInfo.slotLosing}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.sport') }})</em>
                    <span>{{partnerInfo.sportLosing}}</span>
                  </li>
                </ul>
                <ul>
                  <li>{{ $t('front.common.betAndRoll') }}</li>
                  <li>
                    <em>{{ $t('front.bettingStatus.BET') }} / {{ $t('front.stributor.m23') }} ({{ $t('front.gnb.casino') }})</em>
                    <span>{{thousand(partnerInfo.casinoBetAmt || 0)}} / {{thousand(partnerInfo.casinoWinAmt || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.bettingStatus.BET') }} / {{ $t('front.stributor.m23') }} ({{ $t('front.gnb.slot') }})</em>
                    <span>{{thousand(partnerInfo.slotBetAmt || 0)}} / {{thousand(partnerInfo.slotWinAmt || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.bettingStatus.BET') }} / {{ $t('front.stributor.m23') }} ({{ $t('front.gnb.sport') }})</em>
                    <span>{{thousand(partnerInfo.sportBetAmt || 0)}} / {{thousand(partnerInfo.sportWinAmt || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.rolling') }} ({{ $t('front.gnb.casino') }})</em>
                    <span>{{thousand(partnerInfo.casinoRolling || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.rolling') }} ({{ $t('front.gnb.slot') }})</em>
                    <span>{{thousand(partnerInfo.slotRolling || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.rolling') }} ({{ $t('front.gnb.sport') }})</em>
                    <span>{{thousand(partnerInfo.sporttRolling || 0)}}</span>
                  </li>
                </ul>
                <ul>
                  <li>{{ $t('front.common.assetFlow') }}</li>
                  <li>
                    <em>{{ $t('front.common.totalRecharge') }}</em>
                    <span>{{thousand(partnerInfo.cashIn || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.common.totalChange') }}</em>
                    <span>{{thousand(partnerInfo.cashOut || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.common.totalMoney') }}</em>
                    <span>{{thousand(partnerInfo.payment || 0)}}</span>
                  </li>
                  <li>
                    <em>{{ $t('front.common.totalRetri') }}</em>
                    <span>{{thousand(partnerInfo.payback || 0)}}</span>
                  </li>
                  <li class="empty-info">
                    <!-- <em></em>
                    <span></span> -->
                  </li>
                  <li class="empty-info">
                    <!-- <em></em>
                    <span></span> -->
                  </li>
                </ul>
              </div>
              <a class="btnAdd" @click="onChangePartnerAddPopupSub(partnerInfo)">{{ $t('front.common.lowerPart') }}</a>
            </div>
          </div>
          <div class="partnerTop">
            <h4 class="title">※ {{ $t('front.common.lowerPartnerList') }}</h4>
            <div class="select">
              <a @click="partnerListOrder = 'JOIN_DESC'">{{ $t('front.common.latest') }}</a>
              <a @click="partnerListOrder = 'ID_DESC'">{{ $t('front.common.byID') }}</a>
              <a @click="partnerListOrder = 'CASH_DESC'">{{ $t('front.common.byMoney') }}</a>
              <a @click="partnerListOrder = 'POINT_DESC'">{{ $t('front.common.byRolling') }}</a>
            </div>
          </div>
          <div class="strTablescr">
            <div class="strTablePC">
              <table class="strTablePT">
                <colgroup>
                  <col style="width:9%;">
                  <col style="width:6%;">
                  <col style="width:10%;">
                  <col style="width:9%;">
                  <col style="width:6%;">
                  <col style="width:9%;">
                  <col style="width:9%;">
                  <col style="width:9%;">
                  <col style="width:9%;">
                  <col style="width:6%;">
                  <col style="width:9%;">
                  <col style="width:9%;">
                </colgroup>
                <thead>
                  <tr>
                    <th>{{ $t('front.common.memId') }}<br />{{ $t('front.common.nickName') }}</th>
                    <th>{{ $t('front.common.partnerRank') }}</th>
                    <th>{{ $t('front.common.department') }}</th>
                    <th>{{ $t('front.cash.nav3') }}<br />{{ $t('front.cash.nav4') }}</th>
                    <th>{{ $t('front.stributor.dnws') }}</th>
                    <th>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.casino') }})<br />{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.slot') }})</th>
                    <th>{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.casino') }})<br />{{ $t('front.stributor.lose') }} % ({{ $t('front.gnb.slot') }})</th>
                    <th>{{ $t('front.common.moneySum') }}<br />{{ $t('front.common.rollSum') }}</th>
                    <th>{{ $t('front.common.numLowerPart') }}</th>
                    <th>{{ $t('front.stributor.on') }}</th>
                    <th>{{ $t('front.board.regDate') }}</th>
                    <th>{{ $t('front.common.details') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="partnerSubList && partnerSubList.length > 0">
                    <tr v-for="(partner, index) in partnerSubList" :key="partner.memId">
                      <td>
                        {{partner.memId}}<br />
                        <span class="nick">{{partner.memNick}}</span>
                      </td>
                      <td>
                        <span class="box" :class="partner.partnerLevel">{{partner.partnerLevelName}}</span>
                      </td>
                      <td>
                        <div class="topwrap" v-if="partner.topUserList && partner.topUserList.length > 0 && partner.topUserList !== '0'">
                          <select class="h20 upperUser">
                            <option v-for="pt in partner.topUserList" :key="pt.recommenderId">
                                <span>[{{pt.partnerLevelName}}] </span>
                                <span>{{pt.recommenderId}}</span>
                            </option>
                          </select>
                          <i class="icon">+</i>
                        </div>
                        <div v-else>
                          -
                        </div>
                      </td>
                      <td>
                        <div class="twoline-wrap">
                          <span>{{thousand(partner.cashAmt || 0)}}</span>
                          <span>{{thousand(partner.pointAmt || 0)}}</span>
                        </div>
                      </td>
                      <td>
                        <div class="btn-input-wrap flex-c gap-2">
                          <a class="inout-btn btn-green" @click="onOpenPay(partner, index)">{{ $t('front.give.give') }}{{ $t('front.give.back') }}</a>
                          <a class="inout-btn btn-orange" @click="retrieveAll(partner, index)">{{ $t('front.give.allBack') }}</a>
                        </div>
                      </td>
                      <td>
                        <div class="btn-input-wrap">
                          <span class="rate-font roboto">{{partner.casinoRate}}%/{{partner.slotRate}}%</span>
                          <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                        </div>
                      </td>
                      <td>
                        <div class="btn-input-wrap">
                          <span class="rate-font roboto">{{partner.casinoLosing}}%/{{partner.slotLosing}}%</span>
                          <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                        </div>
                      </td>
                      <td>
                        <div class="twoline-wrap">
                          <span>{{thousand(partner.totalBalance.totalCashAmt || 0)}}</span>
                          <span class="plusAmt minusAmt">{{thousand(partner.totalBalance.totalPointAmt || 0)}}</span>
                        </div>
                      </td>
                      <td>
                        <div class="twoline-wrap f-center">
                          <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                            <template v-if="pt.partnerLevel !== 'NORMAL'">
                              <span>{{pt.partnerLevelName}} : {{thousand(pt.cnt || 0)}}</span>
                            </template>
                          </template>
                        </div>
                      </td>
                      <td>
                        <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                          <template v-if="pt.partnerLevel == 'NORMAL'">
                            <span>{{thousand(pt.cnt || 0)}}</span>
                          </template>
                        </template>
                      </td>
                      <td>{{partner.joinDate.replace('T', ' ')}}</td>
                      <td>
                        <div class="btn-input-wrap">
                          <a class="btnp" @click="goToDetail(partner.memId)">{{ $t('front.common.partnerInfo') }} / {{ $t('front.board.re') }}</a>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="12">하부 파트너가 없습니다.</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div class="strTableM">
              <div class="strTablePTM">
                <template v-if="partnerSubList && partnerSubList.length > 0">
                  <ul v-for="(partner, index) in partnerSubList" :key="partner.memId">
                    <li>
                      <em>아이디<br />닉네임</em>
                      <div>
                        {{partner.memId}}<br />
                        <span class="nick">{{partner.memNick}}</span>
                      </div>
                    </li>

                    <li>
                      <em>파트너등급</em>
                      <div>
                        <span class="box" :class="partner.partnerLevel">
                          {{partner.partnerLevelName}}
                        </span>
                      </div>
                    </li>

                    <li>
                      <em>소속</em>
                      <div class="topwrap" v-if="partner.topUserList && partner.topUserList.length > 0 && partner.topUserList !== '0'">
                        <select class="h20 upperUser mw-auto">
                          <option v-for="pt in partner.topUserList" :key="pt.recommenderId">
                            [{{pt.partnerLevelName}}] {{pt.recommenderId}}
                          </option>
                        </select>
                        <i class="icon">+</i>
                      </div>
                      <div v-else>-</div>
                    </li>

                    <li>
                      <em>보유머니<br />보유포인트</em>
                      <div>
                        <span>{{thousand(partner.cashAmt || 0)}}</span><br />
                        <span>{{thousand(partner.pointAmt || 0)}}</span>
                      </div>
                    </li>

                    <li>
                      <em>입출금</em>
                      <div class="flex-c gap-2">
                        <a class="inout-btn" @click="onOpenPay(partner, index)">지급회수</a>
                        <a class="inout-btn btn-orange" @click="retrieveAll(partner, index)">
                          {{ $t('front.give.allBack') }}
                        </a>
                      </div>
                    </li>

                    <li>
                      <em>롤링 % (카)<br />롤링 % (슬)</em>
                      <div class="m-table-r">
                        <span class="rate-font">{{partner.casinoRate}}%/{{partner.slotRate}}%</span>
                        <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                      </div>
                    </li>

                    <li>
                      <em>루징 % (카)<br />루징 % (슬)</em>
                      <div class="m-table-r">
                        <span class="rate-font">{{partner.casinoLosing}}%/{{partner.slotLosing}}%</span>
                        <a class="plus-btn" @click="onOpenRate(partner, index)"></a>
                      </div>
                    </li>

                    <li>
                      <em>총보유머니<br />총보유롤링금</em>
                      <div>
                        <span>{{thousand(partner.totalBalance.totalCashAmt || 0)}}</span><br />
                        <span class="plusAmt minusAmt">
                          {{thousand(partner.totalBalance.totalPointAmt || 0)}}
                        </span>
                      </div>
                    </li>
                    <li>
                      <em>하부수</em>
                      <div>
                        <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                          <template v-if="pt.partnerLevel !== 'NORMAL'">
                            <span>{{pt.partnerLevelName}} : {{thousand(pt.cnt || 0)}}</span>
                          </template>
                        </template>
                      </div>
                    </li>

                    <li>
                      <em>회원 수</em>
                      <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                        <template v-if="pt.partnerLevel == 'NORMAL'">
                          <div>{{thousand(pt.cnt || 0)}}</div>
                        </template>
                      </template>
                    </li>

                    <li>
                      <em>등록일시</em>
                      <div>{{partner.joinDate.replace('T', ' ')}}</div>
                    </li>

                    <li>
                      <em>상세정보</em>
                      <div>
                        <a class="btnp" @click="goToDetail(partner.memId)">
                          파트너정보 / 수정
                        </a>
                      </div>
                    </li>

                  </ul>
                </template>
              </div>
            </div> -->
            <div class="partnerCardM">
              <template v-if="partnerSubList && partnerSubList.length > 0">
                <div class="partnerCard" v-for="(partner, index) in partnerSubList" :key="partner.memId">
                  <div class="partnerCardHead">
                    <div>
                      <strong>{{ partner.memId }}</strong>
                      <span>{{ partner.memNick }}</span>
                    </div>
                    <span class="box" :class="partner.partnerLevel">
                      {{ partner.partnerLevelName }}
                    </span>
                  </div>

                  <div class="partnerCardBody">
                    <div class="row">
                      <em>소속</em>
                      <div class="topwrap" v-if="partner.topUserList && partner.topUserList.length > 0 && partner.topUserList !== '0'">
                        <select class="h20 upperUser mw-auto">
                          <option v-for="pt in partner.topUserList" :key="pt.recommenderId">
                            [{{pt.partnerLevelName}}] {{pt.recommenderId}}
                          </option>
                        </select>
                        <i class="icon">+</i>
                      </div>
                      <span v-else>-</span>
                    </div>

                    <div class="row">
                      <em>보유머니</em>
                      <span>{{ thousand(partner.cashAmt || 0) }}</span>
                    </div>

                    <div class="row">
                      <em>보유포인트</em>
                      <span>{{ thousand(partner.pointAmt || 0) }}</span>
                    </div>

                    <div class="row">
                      <em>입출금</em>
                      <div class="btns">
                        <a class="inout-btn btn-green" @click="onOpenPay(partner, index)">지급회수</a>
                        <a class="inout-btn btn-orange" @click="retrieveAll(partner, index)">전체회수</a>
                      </div>
                    </div>

                    <div class="row">
                      <em>롤링</em>
                      <span>{{ partner.casinoRate }}% / {{ partner.slotRate }}%</span>
                    </div>

                    <div class="row">
                      <em>루징</em>
                      <span>{{ partner.casinoLosing }}% / {{ partner.slotLosing }}%</span>
                    </div>

                    <div class="row">
                      <em>총보유머니</em>
                      <span>{{ thousand(partner.totalBalance.totalCashAmt || 0) }}</span>
                    </div>

                    <div class="row">
                      <em>총보유롤링금</em>
                      <span>{{ thousand(partner.totalBalance.totalPointAmt || 0) }}</span>
                    </div>

                    <div class="row">
                      <em>하부수</em>
                      <span>
                        <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                          <template v-if="pt.partnerLevel !== 'NORMAL'">
                            {{ pt.partnerLevelName }} : {{ thousand(pt.cnt || 0) }}
                          </template>
                        </template>
                      </span>
                    </div>

                    <div class="row">
                      <em>회원수</em>
                      <span>
                        <template v-for="pt in partner.countInfo" :key="pt.partnerLevel">
                          <template v-if="pt.partnerLevel == 'NORMAL'">
                            {{ thousand(pt.cnt || 0) }}
                          </template>
                        </template>
                      </span>
                    </div>

                    <div class="row">
                      <em>등록일시</em>
                      <span>{{ partner.joinDate.replace('T', ' ') }}</span>
                    </div>
                  </div>

                  <a class="partnerCardBtn" @click="goToDetail(partner.memId)">
                    파트너정보 / 수정
                  </a>
                </div>
              </template>

              <div class="partnerCardEmpty" v-else>
                하부 파트너가 없습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    <div v-if="makesub" class="makePopupDim" @click="makesub = false"></div>
    <div v-if="makesub" class="moveWrap2 makePopup">
      <div class="tabmenu_make moveWraphead">
        <ul>
          <li @click="currentTab = 'makeTab1'" :class="{'current': currentTab == 'makeTab1'}">{{ $t('front.common.partner') }}</li>
          <li @click="currentTab = 'makeTab2'" :class="{'current': currentTab == 'makeTab2'}">{{ $t('front.common.member') }}</li>
        </ul>
        <a class="close" @click="makesub = false"><img src="@/assets/img/icon_cancel.svg" /></a>
      </div>
      <div class="tabcont_make moveWrapbody" v-if="currentTab == 'makeTab1' && newPartner.partnerLevel !== 'PTN_7'" >
        <h4>{{ $t('front.common.makePartner') }}</h4>
        <table class="part">
          <colgroup>
            <col width="20%"/>
            <col width="30%"/>
            <col width="20%"/>
            <col width="30%"/>
          </colgroup>
          <tr>
            <th>{{ $t('front.common.memId') }}</th>
            <td><input class="in" name="newMemId" type="text" v-model="newPartner.memId" autocomplete="off" role="presentation"/></td>
            <th>{{ $t('front.common.password') }}</th>
            <td><input class="in" name="newMemPass" type="password" v-model="newPartner.memPass" autocomplete="off"/></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.nickName') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memNick" /></td>
            <th>{{ $t('front.cash.withdrawPassword') }}</th>
            <td><input class="in password" pattern="[0-9]*" type="text" v-model="newPartner.cashOutPass" /></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.recommandId') }}</th>
            <td>{{newPartner.recommenderId}}({{newPartner.partnerLevelName}})</td>
            <th>{{ $t('front.common.accountInfo') }}</th>
            <td class="accountInfo">
              <bank-list :className="'in'" @onChange="onChangeBank"></bank-list>
              <input class="in w45w" type="text" v-model="newPartner.bankAcc"/>
            </td>
          </tr>
          <tr>
            <th>{{ $t('front.stributor.name') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memName" /></td>
            <th>{{ $t('front.common.tel') }}</th>
            <td><input class="in" type="text" v-model="newPartner.memPhone" /></td>
          </tr>
        </table>
        <h4>{{ $t('front.common.gameRate') }}</h4>
        <!--table v-if="isWideScreen">
          <tr>
            <th :colspan="Object.keys(newPartner.rateGroup).length">{{$t('front.stributor.roll')}}(%)</th>
            <th :colspan="Object.keys(newPartner.rateGroup).length">{{$t('front.stributor.lose')}}(%)</th>
          </tr>
          <tr>
            <th v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
              {{$t(`front.gnb.${key}`)}}
            </th>
            <th v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
              {{$t(`front.gnb.${key}`)}}
            </th>
          </tr>
          <tr>
            <td v-for="(item) in newPartner.rateGroup" v-bind:key="item">
              <a class="rbnt">최대값 : {{item.maxPointRate}}</a><br>
              <a class="rbnt">최소값 : {{item.minPointRate}}</a>
            </td>
            <td v-for="(item) in newPartner.rateGroup" v-bind:key="item">
              <a class="rbnt">최대값 : {{item.maxLoseRate}}</a><br>
              <a class="rbnt">최소값 : {{item.minLoseRate}}</a>
            </td>
          </tr>
          <tr>
            <td v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
              <input type="text" v-model="item[`${key}PR`]">
            </td>
            <td v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
              <input type="text" v-model="item[`${key}LR`]">
            </td>
          </tr>
        </table>
        <ul class="rateset-m" v-if="!isWideScreen">
          <li class="table-name">롤링(%)</li>
          <li>
            <table>
              <tr v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
                <td>{{$t(`front.gnb.${key}`)}}</td>
                <td>
                  <a class="rbnt">최대값 : {{item.maxPointRate}}</a><br>
                  <a class="rbnt">최소값 : {{item.minPointRate}}</a>
                </td>
                <td>
                  <input type="text" v-model="item[`${key}PR`]">
                </td>
              </tr>
            </table>
          </li>
          <li class="table-name">루징(%)</li>
          <li>
            <table>
              <tr v-for="(item, key) in newPartner.rateGroup" v-bind:key="item">
                <td>{{$t(`front.gnb.${key}`)}}</td>
                <td>
                  <a class="rbnt">최대값 : {{item.maxLoseRate}}</a><br>
                  <a class="rbnt">최소값 : {{item.minLoseRate}}</a>
                </td>
                <td>
                  <input type="text" v-model="item[`${key}LR`]">
                </td>
              </tr>
            </table>
          </li>
        </ul-->
        <a class="btn" @click="onAddPartnerSubmit">{{ $t('front.board.reg') }}</a>
    </div>

      <div class="tabcont_make moveWrapbody" v-if="currentTab == 'makeTab2'">
        <h4>{{ $t('front.common.makeMember') }}</h4>
        <table class="part">
          <colgroup>
            <col width="20%"/>
            <col width="30%"/>
            <col width="20%"/>
            <col width="30%"/>
          </colgroup>
          <tr>
            <th>{{ $t('front.common.memId') }}</th>
            <td><input class="in" type="text" autocomplete="off" v-model="newMember.memId"/></td>
            <th>{{ $t('front.common.cashOutPass') }}</th>
            <td><input class="in password" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" maxlength="4" pattern="[0-9]*" v-model="newMember.cashOutPass" inputmode="numeric"  /></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.password') }}</th>
            <td><input class="in" type="password" autocomplete="off" v-model="newMember.memPass"/></td>
            <th>{{ $t('front.common.tel') }}</th>
            <td><input class="in" type="text" v-model="newMember.memPhone"/></td>
          </tr>
          <tr>
            <th>{{ $t('front.common.nickName') }}</th>
            <td><input class="in" type="text" v-model="newMember.memNick"/></td>
            <th>{{ $t('front.common.recommandId') }}</th>
            <td>{{newPartner.recommenderId}}({{newPartner.partnerLevelName}})
              <input class="in" type="hidden" v-model="newMember.recommenderId"/>
            </td>
          </tr>
          <tr>
            <th>{{ $t('front.stributor.name') }}</th>
            <td><input class="in" type="text" v-model="newMember.memName"/></td>
            <th>{{ $t('front.common.accountInfo') }}</th>
            <td class="accountInfo">
              <bank-list :className="'in'" @onChange="onChangeBankMember"></bank-list>
              <input class="in w45w" type="text" v-model="newMember.bankacc" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" />
            </td>
          </tr>
        </table>
        <a class="btn" @click="newMemberSignup()">{{ $t('front.board.reg') }}</a>
      </div>
    </div>
    <pagination />
    <transition name="fade">
      <RateTable v-if="RateOpen" :selectMem="selectMem" :selectIdx="selectIdx"  @close="onCloseRate"/>
    </transition>
    <transition name="fade">
      <Paymodal v-if="PayMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePay"/>
    </transition>
  </div>
</template>

<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import RateTable from '@/components/common/RateTable.vue'
import Paymodal from '@/components/common/Pay.vue'
import { memCashInOut } from '@/api/give'
import Pagination from '@/components/ui/Pagination.vue'
import BankList from '@/components/ui/BankList.vue'
import { mapState } from 'vuex'
import { partnerRates, retailMyPartnerDirectList } from '@/api/retail'
import {
  getPartnerInfoV2,
  getPartnerListV2,
  partnerJoinV2,
  updatePartnerInfoPhoneV2
} from '@/api/v2/partner'
import {
  getDateStr,
  isValidOnlyNumber, isValidOnlyPhoneNumber,
  isValidPassword,
  isValidPasswordPartner,
  isValidUserId,
  thousand
} from '@/libs/utils'
import { addDays } from 'date-fns'
import { signUp } from '@/api/member'
import PartnerHierarchy from '@/components/common/mobile/PartnerHierarchy.vue'
import { PARTNER_LEVEL_ORDER } from '@/libs/constants'
export default {
  name: 'PartnerCash',
  components: { PartnerHierarchy, DateFilterPt, Pagination, RateTable, Paymodal, BankList },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ]),
    PARTNER_LEVEL_ORDER () {
      return PARTNER_LEVEL_ORDER
    }
  },
  data () {
    return {
      partnerTreeOpen: false,
      PayMopen: false,
      RateOpen: false,
      makesub: false,
      currentTab: 'makeTab1',
      partnerList: null,
      partnerSubList: null,
      partnerListOrder: 'JOIN_DESC',
      infoDate: {
        startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
        endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
      },
      partnerInfo: null,
      selectMem: null,
      selectIdx: null,
      selectedLi: null,
      newPartner: {
        memId: '',
        memPass: '',
        memNick: '',
        memPhone: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        rateGroup: {}
      },
      newMember: {
        memId: '',
        memPass: '',
        memNick: '',
        memPhone: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        memLevel: '1',
        partSendYn: 'N',
        firstBetConfYn: 'N',
        memStatus: 0
      },
      defaultMember: {
        memId: '',
        memPass: '',
        memNick: '',
        memPhone: '',
        bank: '',
        bankAcc: '',
        cashOutPass: '',
        memLevel: '1',
        partSendYn: 'N',
        firstBetConfYn: 'N',
        memStatus: 0
      },
      rateMaxMinList: [],
      newPartnerLevel: {}
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    // await this.getHierarchyList('', 'main', null)
    await this.loadInfo(this.userData.memId)
    await this.loadSubList(this.userData.memId, 1)
    this.selectedLi = this.userData.memId
    this.emitter.emit('Loading', false)
  },
  watch: {
    partnerListOrder () {
      this.loadSubList(this.selectedLi, 1, 'sub')
    }
  },
  methods: {
    thousand,
    updateInfoDate (value) {
      this.infoDate = { ...value }
    },
    isMemberSignupValidate () {
      const data = this.newMember
      for (const key of Object.keys(data)) {
        const value = data[key]
        if (key === 'memId') {
          if (value === '') {
            this.onAlert('warningart', 'front.member.emptyMemId')
            return false
          }

          if (!isValidUserId(value)) {
            this.onAlert('warningart', 'api.U101')
            return false
          }
        }

        if (key === 'memPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemPass')
            return false
          }

          if (!isValidPassword(value) || value.length > 20) {
            this.onAlert('warningart', 'api.U102')
            return false
          }
        }

        if (key === 'cashOutPass') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyCashOutPass')
            return false
          }

          if (!isValidOnlyNumber(value) || value.length !== 4) {
            this.onAlert('warningart', 'api.U103')
            return false
          }
        }

        if (key === 'memNick') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemName')
            return false
          }

          if (value.length > 20 || value.length < 3) {
            this.onAlert('warningart', 'api.U105')
            return false
          }
        }

        if (key === 'memPhone') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyMemTel')
            return false
          }

          if (!isValidOnlyPhoneNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidMemTel')
            return false
          }
        }

        if (key === 'recommenderId') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyRecommenderId')
            return false
          }
        }

        if (key === 'bank') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankName')
            return false
          }
        }

        if (key === 'memName') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankAccountName')
            return false
          }
        }

        if (key === 'bankacc') {
          if (data[key] === '') {
            this.onAlert('warningart', 'front.member.emptyBankNumber')
            return false
          }

          if (!isValidOnlyNumber(value)) {
            this.onAlert('warningart', 'front.member.noValidBankNumber')
            return false
          }
        }
      }

      return true
    },
    newMemberSignup () {
      this.newMember.recommenderId = this.newPartner.recommenderId
      if (this.isMemberSignupValidate()) {
        this.newMember.memPhone = this.newMember.memPhone.toString()
        signUp(this.newMember).then(async response => {
          const result = response.data
          if (result.resultCode === '0') {
            await this.onCheck('front.member.completeSignup')
            this.makesub = false
            this.newMember = {
              ...this.defaultMember
            }
          } else {
            this.onAlert('warningart', 'api.' + result.resultCode)
          }
        }).catch(err => {
          console.error('singup err : ', err)
        })
      }
    },
    onAddPartnerSubmit () {
      this.emitter.emit('Loading', true)
      const reqData = { ...this.newPartner, rateGroup: {} }

      for (const groupCode in this.newPartner.rateGroup) {
        const item = this.newPartner.rateGroup[groupCode]
        const pr = item[`${groupCode}PR`]
        if (pr) {
          if (Number(item.maxPointRate) < Number(pr) || Number(item.minPointRate) > Number(pr)) {
            this.onAlert('warningart', `front.stributor.${groupCode}RollingError`)
            this.emitter.emit('Loading', false)
            return false
          }
        } else {
          this.onAlert('warningart', `front.stributor.${groupCode}RollingError`)
          this.emitter.emit('Loading', false)
          return false
        }
        const lr = item[`${groupCode}LR`]
        if (lr) {
          if (Number(item.maxLoseRate) < Number(lr) || Number(item.minLoseRate) > Number(lr)) {
            this.onAlert('warningart', `front.stributor.${groupCode}LoseError`)
            this.emitter.emit('Loading', false)
            return false
          }
        } else {
          this.onAlert('warningart', `front.stributor.${groupCode}LoseError`)
          this.emitter.emit('Loading', false)
          return false
        }

        reqData.rateGroup[`${groupCode}PR`] = pr
        reqData.rateGroup[`${groupCode}LR`] = lr
      }

      if (!reqData.memId) {
        this.onAlert('warningart', 'front.member.emptyMemId')
        this.emitter.emit('Loading', false)
        return false
      }

      if (!isValidUserId(reqData.memId)) {
        this.onAlert('warningart', 'api.U101')
        this.emitter.emit('Loading', false)
        return false
      }

      if (!reqData.memPass) {
        this.onAlert('warningart', 'front.member.emptyMemPass')
        this.emitter.emit('Loading', false)
        return false
      }

      if (!isValidPasswordPartner(reqData.memPass) || reqData.memPass.length > 20) {
        this.onAlert('warningart', 'api.U102')
        this.emitter.emit('Loading', false)
        return false
      }

      if (!reqData.memNick) {
        this.onAlert('warningart', 'front.member.emptyMemNick')
        this.emitter.emit('Loading', false)
        return false
      }
      if (!reqData.cashOutPass) {
        this.onAlert('warningart', 'front.member.emptyCashOutPass')
        this.emitter.emit('Loading', false)
        return false
      }
      if (!reqData.bank) {
        this.onAlert('warningart', 'front.member.emptyBankName')
        this.emitter.emit('Loading', false)
        return false
      }
      if (!reqData.bankAcc) {
        this.onAlert('warningart', 'front.member.emptyBankNumber')
        this.emitter.emit('Loading', false)
        return false
      }
      if (!reqData.memName) {
        this.onAlert('warningart', 'front.member.emptyMemName')
        this.emitter.emit('Loading', false)
        return false
      }
      if (!reqData.memPhone) {
        this.onAlert('warningart', 'front.member.emptyMemTel')
        this.emitter.emit('Loading', false)
        return false
      }

      return partnerJoinV2(reqData).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.onCheck('하위파트너 생성신청이 완료되었습니다. 관리자에서 승인되면 가입처리가 완료됩니다.')
          this.onChangePartnerAddPopupSub(this.partnerInfo)
          this.newPartner = { ...this.defaultNewPartner }
          this.emitter.emit('Loading', false)
        } else {
          this.emitter.emit('Loading', false)
          this.onAlert('warningart', result.resultMessage)
        }
      })
    },
    onChangeBank (value) {
      this.newPartner.bank = value
    },
    onChangeBankMember (value) {
      this.newMember.bank = value
    },
    async onChangePartnerAddPopupSub (currentPartner) {
      if (!this.isMemberMake(currentPartner.partnerLevel)) {
        this.currentTab = 'makeTab1'
      }

      this.makesub = !this.makesub
      if (this.makesub) {
        console.log(this.rateMaxMinList)

        const list = await this.getPartnerRateForNewPartner(currentPartner.memId)

        this.newPartner.recommenderId = currentPartner.memId
        this.newPartner.partnerLevel = currentPartner.partnerLevel
        this.newPartner.partnerLevelName = currentPartner.partnerLevelName

        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          const vendorCode = item.vendorCode
          let groupCode = this.commonCodeByCode[vendorCode].groupCode
          const groupCodeName = this.commonCodeByCode[vendorCode].groupCodeName
          if (groupCode === 'minigame') {
            groupCode = 'mini'
          }
          if (groupCode === 'casino' && groupCodeName.indexOf('HC-') > -1) {
            groupCode = 'hcasino'
          }
          if (groupCode) {
            this.newPartner.rateGroup[groupCode] = {
              ...item
            }
            this.newPartner.rateGroup[groupCode][`${groupCode}PR`] = '0.0'
            this.newPartner.rateGroup[groupCode][`${groupCode}LR`] = '0.0'
          }
          console.log(groupCode)
        }
      }
    },
    getPartnerRateForNewPartner (memId) {
      const params = {}
      if (memId) {
        params.memId = memId
      } else {
        params.memId = this.userData.memId
      }
      return partnerRates(params).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          const list = result.data.rateMaxMinList
          // this.rateMaxMinList = list
          return list
        }
      })
    },
    onChangePhone (memId, newPhone) {
      const params = {
        memId: memId,
        memPhone: newPhone
      }

      if (confirm('전화번호를 변경하시겠습니까?')) {
        updatePartnerInfoPhoneV2(params).then(res => {
          const result = res.data
          if (result.resultCode === '0') {
            alert('정상적으로 변경되었습니다.')
          } else {
            alert('다시 시도해주세요 :', result.resultMessage)
          }
        })
      }
    },
    goToDetail (memId) {
      this.detailOpen('partner', memId)
    },
    onCloseRate () {
      this.RateOpen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onClosePay (newCash, idx) {
      if (newCash !== null && newCash !== undefined) {
        this.partnerSubList[idx].cashAmt = newCash
      }
      this.PayMopen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onOpenPay (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.PayMopen = true
    },
    async retrieveAll (partner, index) {
      if (!partner.cashAmt || partner.cashAmt === '0' || partner.cashAmt === 0) {
        alert('회수할 금액이 없습니다.')
        return
      }
      const cfval = confirm('전체 회수처리하시겠습니까?')
      if (cfval) {
        this.emitter.emit('Loading', true)
        const req = {
          memId: partner.memId,
          outAmt: partner.cashAmt,
          memo: '',
          type: '',
          bonusRollingYn: 'N'
        }
        const res = await memCashInOut(req, '3')
        const result = res.data
        if (result.resultCode === '0') {
          alert('회수 완료')
          partner.cashAmt = 0
          this.emitter.emit('Loading', false)
        } else {
          this.emitter.emit('Loading', false)
          alert('회수 실패: ' + result.resultMessage)
        }
      }
    },
    onOpenRate (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.RateOpen = true
    },
    async loadInfo (memId) {
      const param = {
        memId: memId,
        ...this.infoDate
      }

      getPartnerInfoV2(param).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerInfo = result.data.partnerInfo
        }
      })
    },
    async loadSubList (memId, page, type) {
      if (!page) {
        page = this.pageInfo.page
      } else {
        this.pageInfo.page = page
      }
      this.emitter.emit('Loading', true)

      const params = {
        memId: memId,
        targetLevel: '',
        searchType: 'id',
        searchValue: '',
        orderStr: this.partnerListOrder,
        page: page,
        count_per_list: 40
      }

      await getPartnerListV2(params, type).then(res => {
        this.emitter.emit('Loading', false)
        const result = res.data
        if (result.resultCode === '0') {
          this.partnerSubList = result.data.list

          this.partnerSubList.forEach(item => {
            const topUserList = []
            if (item.topUserList) {
              item.topUserList.forEach(pt => {
                if (this.userData.partnerLevelOrder <= PARTNER_LEVEL_ORDER[pt.partnerLevel]) {
                  topUserList.push(pt)
                }
              })
            }
            item.topUserList = topUserList
          })
        }

        if (result.data.pageInfo) {
          this.pageInfo = result.data.pageInfo
        } else {
          this.pageInfo.page = 1
          this.pageInfo.tatal_list_count = 0
        }
      })
    },
    onClickPartnerTree (memId, type, item) {
      this.getMyPartnerList(memId, type, item)

      if (window.innerWidth <= 1000) {
        this.partnerTreeOpen = false
      }
    },
    getMyPartnerList (memId, type, item) {
      this.emitter.emit('Loading', true)
      const params = {
        memId: memId
      }
      retailMyPartnerDirectList(params, type).then(res => {
        const result = res.data
        if (result.resultCode === '0') {
          const list = result.data.list
          if (type === 'sub') {
            item.children = null
            item.children = list

            if (this.selectedLi === memId) {
              this.selectedLi = memId
            } else {
              this.selectedLi = memId
            }

            this.loadSubList(memId, 1, type)
            this.loadInfo(memId)
          } else {
            this.partnerList = list
          }
        }
        this.emitter.emit('Loading', false)
      })
    }
    // getHierarchyList (memId, type, item) {
    //   this.emitter.emit('Loading', true)
    //   const params = {
    //     memId: memId
    //   }
    //   return getPartnerHierarchyV2(params).then(res => {
    //     const result = res.data
    //     console.log('getPartnerHierarchyV2 : ', params, result)
    //     const list = result.data.hierarchy
    //     if (type === 'sub') {
    //       item.children = list
    //       item.open = !item.open
    //       if (this.selectedLi === memId) {
    //         this.selectedLi = memId
    //       } else {
    //         this.selectedLi = memId
    //       }
    //
    //       // this.loadSubList(memId, 1, type)
    //     } else {
    //       this.partnerList = list
    //     }
    //
    //     this.emitter.emit('Loading', false)
    //
    //     return true
    //   })
    // }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
.w100 {
  width: 100%;
  min-width: 0;
}

/* ================= 화이트 버전 기본 레이아웃 ================= */
.tab-content {
  min-height: calc(100vh - 55px);
  padding: 18px 18px 42px;
  background: #f4f7fb;
  color: #172033;
  box-sizing: border-box;
}

.pagenamPT {
  display: flex;
  align-items: center;
  min-height: 34px;
  margin: 0 0 14px;
}

.pagename2 {
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #172033;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.pagename2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 4px;
  height: 18px;
  border-radius: 3px;
  background: #2f7df6;
}

.partnerTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
  padding: 13px 16px;
  border: 1px solid #e1e7f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(20, 35, 58, 0.06);
}

.pagenamPT + .partnerTop {
  justify-content: flex-end;
}

.strTableWrap {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  background: transparent;
  box-sizing: border-box;
}

.strTablescr {
  width: 100%;
  margin-bottom: 16px;
  padding: 14px;
  border: 1px solid #e1e7f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(20, 35, 58, 0.06);
  box-sizing: border-box;
  overflow: visible;
}

.strTablescr > div {
  width: 100%;
}

/* ================= 트리 영역 ================= */
.partnerTreePc {
  flex: 0 0 250px;
  width: 250px;
  min-width: 250px;
  padding: 14px;
  border: 1px solid #e1e7f0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(20, 35, 58, 0.06);
  box-sizing: border-box;
}

.partnerTreePc :deep(.subMemWrap),
.partnerTreeDropdown :deep(.subMemWrap) {
  width: 100%;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.partnerTreePc :deep(.subMemWrap h4),
.partnerTreeDropdown :deep(.subMemWrap h4) {
  margin: 0 0 12px;
  color: #172033;
  font-size: 14px;
  font-weight: 800;
}

.partnerTreePc :deep(li),
.partnerTreeDropdown :deep(li) {
  color: #263244;
}

/* ================= 상단 파트너 정보 ================= */
.partnerInfo {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin: 0;
  padding: 0;
  background: #fff;
}

h4.title {
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #172033;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.3;
}

h4.title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 4px;
  height: 17px;
  border-radius: 3px;
  background: #7c5cff;
}

.infoView {
  display: grid;
  grid-template-columns: repeat(4, minmax(190px, 1fr));
  gap: 14px;
  width: 100%;
}

.partnerInfo ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.partnerInfo ul li {
  display: flex;
  flex-direction: column;
  min-height: 68px;
  overflow: hidden;
  border: 1px solid #e2e7f0;
  border-radius: 7px;
  background: #fff;
  box-shadow: none;
  box-sizing: border-box;
  color: #172033;
  font-weight: 700;
}

.partnerInfo ul li:first-child {
  justify-content: center;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #dce4ef;
  background: #eef3fb;
  color: #172033;
  font-size: 14px;
  font-weight: 800;
  box-shadow: none;
}

.partnerInfo ul li em {
  display: flex;
  align-items: center;
  min-height: 28px;
  padding: 0 12px;
  border-bottom: 1px solid #edf1f6;
  background: #f8fafc;
  color: #5f6b7a;
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
}

.partnerInfo ul li span {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 12px;
  color: #172033;
  font-size: 14px;
  font-weight: 700;
  word-break: break-all;
}

.partnerInfo ul .empty-info {
  display: none;
}

.partnerInfo .number {
  gap: 8px;
}

.partnerInfo .number input {
  flex: 1;
  min-width: 0;
  height: 28px;
  padding: 0 9px;
  border: 1px solid #d7deea;
  border-radius: 6px;
  background: #fff;
  color: #172033;
  box-sizing: border-box;
}

/* ================= 버튼 / 폼 ================= */
.select {
  display: flex;
  align-items: center;
  gap: 6px;
}

.select a,
.btnAdd,
.btnp,
.inout-btn,
.dateBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
}

.select a {
  height: 32px;
  padding: 0 13px;
  border: 1px solid #d7deea;
  border-radius: 6px;
  background: #fff;
  color: #536071;
  font-size: 13px;
  font-weight: 700;
  transition: 0.15s ease;
}

.select a.on,
.select a:hover {
  border-color: #2f7df6;
  background: #2f7df6;
  color: #fff;
}

.btnAdd {
  align-self: flex-end;
  height: 32px;
  margin: 0;
  padding: 0 18px;
  border-radius: 6px;
  background: #5f54d9;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 5px 12px rgba(95, 84, 217, 0.22);
}

.btnAdd:hover,
.btnp:hover,
.partnerCardBtn:hover {
  filter: brightness(0.96);
}

.btnp {
  min-height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  background: #6f61d8;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  box-shadow: none;
}

.inout-btn {
  min-width: 58px;
  min-height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  background: #2f7df6;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: none;
}

.btn-green {
  background: #10a66a !important;
}

.btn-orange {
  background: #f59f00 !important;
}

.btn-input-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.flex-c {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.gap-2 {
  gap: 4px;
}

.twoline-wrap {
  display: flex;
  flex-direction: column;
  gap: 5px;
  line-height: 1.2;
}

.f-center {
  align-items: center;
}

.rate-font {
  color: #445165;
  font-size: 12px;
  font-weight: 800;
}

.plus-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #6f7784;
  color: #fff;
  cursor: pointer;
  vertical-align: middle;
}

.plus-btn::before {
  content: '+';
  margin-top: -1px;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
}

.nick,
.plusAmt.minusAmt {
  color: #ff6b00;
  font-weight: 800;
}

.box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  height: 23px;
  padding: 0 8px;
  border-radius: 5px;
  background: #e8efff;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-sizing: border-box;
}

.upperUser,
.h20 {
  height: 26px !important;
  border: 1px solid #cfd7e4 !important;
  border-radius: 5px !important;
  background: #fff !important;
  color: #334155 !important;
  font-size: 12px !important;
}

.topwrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.topwrap .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #6f7784;
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

/* ================= 테이블 ================= */
.strTablePC {
  width: 100%;
  overflow-x: auto;
}

.strTablePT {
  width: 100%;
  min-width: 1040px;
  border: 1px solid #dfe6ef;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  color: #172033;
  font-size: 13px;
}

.strTablePT thead th {
  height: 48px;
  padding: 10px 8px;
  border: 0;
  border-bottom: 1px solid #d6dfeb;
  background: #eaf1f9;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
}

.strTablePT tbody td {
  min-height: 54px;
  padding: 12px 8px;
  border: 0;
  border-bottom: 1px solid #e8edf4;
  background: #fff;
  color: #172033;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
}

.strTablePT tbody tr:nth-child(even) td {
  background: #fbfcfe;
}

.strTablePT tbody tr:hover td {
  background: #f2f6fb;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0;
}

/* ================= 모바일 기본 숨김 ================= */
.partnerCardM,
.partnerTreeMobileBtn,
.partnerTreeDropdown {
  display: none;
}

/* ================= 팝업 ================= */
.makePopupDim {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 998;
}

.moveWrap2.makePopup {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 760px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 60px);
  transform: translate(-50%, -50%);
  overflow-y: auto;
  border: 1px solid #e1e7f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.28);
  z-index: 999;
}

.moveWrap2.makePopup .moveWraphead {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 62px;
  padding: 0 22px;
  border-bottom: 1px solid #e1e7f0;
  background: #f8fafc;
}

.moveWrap2.makePopup .tabmenu_make > ul {
  display: flex;
  gap: 8px;
  margin: 0;
  padding: 0;
}

.moveWrap2.makePopup .tabmenu_make > ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #d7deea;
  border-radius: 8px;
  background: #fff;
  color: #536071;
  font-weight: 800;
  cursor: pointer;
}

.moveWrap2.makePopup .tabmenu_make > ul li.current {
  border-color: #5f54d9;
  background: #5f54d9;
  color: #fff;
}

.moveWrap2.makePopup .close {
  position: static;
  cursor: pointer;
}

.moveWrap2.makePopup .close img {
  width: 24px;
  height: 24px;
}

.moveWrap2.makePopup .moveWrapbody {
  padding: 24px 30px 28px;
}

.moveWrap2.makePopup h4 {
  margin: 0 0 14px;
  color: #172033;
  font-size: 16px;
  font-weight: 900;
}

.moveWrap2.makePopup table.part {
  width: 100%;
  border-collapse: collapse;
}

.moveWrap2.makePopup table.part tr {
  display: grid;
  grid-template-columns: 100px minmax(180px, 1fr) 100px minmax(180px, 1fr);
  gap: 8px 12px;
  align-items: center;
  margin-bottom: 10px;
}

.moveWrap2.makePopup table.part th,
.moveWrap2.makePopup table.part td {
  height: auto;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #172033;
  text-align: left;
}

.moveWrap2.makePopup table.part th {
  color: #5f6b7a;
  font-size: 13px;
  font-weight: 800;
}

.moveWrap2.makePopup input.in,
.moveWrap2.makePopup select.in {
  width: 100% !important;
  min-width: 0 !important;
  height: 36px !important;
  padding: 0 10px !important;
  border: 1px solid #d7deea !important;
  border-radius: 7px !important;
  background: #fff !important;
  box-sizing: border-box;
}

.moveWrap2.makePopup .accountInfo {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 6px;
  align-items: center;
}

.moveWrap2.makePopup a.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  float: none;
  width: 160px;
  height: 38px;
  margin: 22px 0 0 auto;
  padding: 0;
  border-radius: 8px;
  background: #5f54d9;
  color: #fff;
  font-weight: 800;
}

/* ================= 모바일 ================= */
@media (max-width: 1000px) {
  .tab-content {
    padding: 14px 12px 28px;
  }

  .pagename2 {
    font-size: 17px;
  }

  .pagenamPT + .partnerTop,
  .partnerTop {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 10px;
    padding: 12px;
  }

  .strTableWrap {
    display: block;
  }

  .partnerTreePc,
  .strTablePC {
    display: none;
  }

  .strTablescr {
    padding: 12px;
    overflow-x: hidden;
    box-shadow: 0 5px 14px rgba(20, 35, 58, 0.06);
  }

  .strTablescr > div {
    overflow-x: hidden;
    white-space: normal;
  }

  .partnerTreeMobileBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 14px;
    margin-bottom: 8px;
    border-radius: 8px;
    background: #5f54d9;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .partnerTreeMobileBtn::after {
    content: '›';
    font-size: 22px;
  }

  .partnerTreeDropdown {
    display: block;
    width: 100%;
    max-height: 420px;
    margin-bottom: 15px;
    padding: 12px;
    overflow-y: auto;
    border: 1px solid #e1e7f0;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(20, 35, 58, 0.08);
    box-sizing: border-box;
  }

  .infoView {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .partnerInfo ul {
    gap: 7px;
  }

  .partnerInfo .number {
    align-items: stretch;
  }

  .btnAdd {
    width: 100%;
    height: 40px;
    justify-content: center;
  }

  .select {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
    width: 100%;
  }

  .select a {
    width: 100%;
    height: 36px;
    padding: 0 5px;
    border-radius: 8px;
    font-size: 12px;
  }

  .partnerCardM {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
  }

  .partnerCard {
    overflow: hidden;
    border: 1px solid #e1e7f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 6px 16px rgba(20, 35, 58, 0.07);
  }

  .partnerCardHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 14px 15px;
    border-bottom: 1px solid #e5ebf3;
    background: #eef3fb;
  }

  .partnerCardHead strong {
    display: block;
    color: #172033;
    font-size: 16px;
    line-height: 1.2;
  }

  .partnerCardHead span:not(.box) {
    display: block;
    margin-top: 4px;
    color: #ff6b00;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.2;
  }

  .partnerCardHead .box {
    flex-shrink: 0;
    width: auto;
    min-width: 42px;
    height: 24px;
    border-radius: 12px;
  }

  .partnerCardBody {
    padding: 6px 14px 4px;
  }

  .partnerCardBody .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 42px;
    padding: 7px 0;
    border-bottom: 1px solid #edf1f6;
    font-size: 13px;
  }

  .partnerCardBody .row em {
    flex: 0 0 105px;
    color: #5f6b7a;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 1.3;
  }

  .partnerCardBody .row span,
  .partnerCardBody .row > div {
    flex: 1;
    justify-content: flex-end;
    color: #172033;
    font-weight: 700;
    text-align: right;
    word-break: break-all;
  }

  .partnerCardBody .btns {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }

  .partnerCardBody .topwrap {
    width: 100%;
    max-width: 180px;
    margin-left: auto;
  }

  .partnerCardBody .topwrap select.upperUser {
    height: 28px !important;
    font-size: 11px !important;
  }

  .partnerCardBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    margin: 8px 14px 14px;
    border-radius: 9px;
    background: #5f54d9;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .partnerCardEmpty {
    padding: 35px 12px;
    border: 1px solid #e1e7f0;
    border-radius: 12px;
    background: #fff;
    color: #6b737c;
    text-align: center;
    font-size: 14px;
  }

  .moveWrap2.makePopup {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    max-height: calc(100vh - 40px);
    border-radius: 12px;
  }

  .moveWrap2.makePopup .moveWraphead {
    min-height: 58px;
    padding: 12px;
  }

  .moveWrap2.makePopup .tabmenu_make > ul li {
    min-width: 74px;
    height: 32px;
    font-size: 12px;
  }

  .moveWrap2.makePopup .moveWrapbody {
    padding: 18px 15px 22px;
  }

  .moveWrap2.makePopup table.part tr {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 12px;
  }

  .moveWrap2.makePopup table.part th,
  .moveWrap2.makePopup table.part td {
    width: 100% !important;
  }

  .moveWrap2.makePopup input.in,
  .moveWrap2.makePopup select.in {
    height: 38px !important;
  }

  .moveWrap2.makePopup .accountInfo {
    grid-template-columns: 1fr;
  }

  .moveWrap2.makePopup a.btn {
    width: 100%;
    height: 42px;
    margin-top: 18px;
  }
}
</style>

<style scoped>
@media (min-width: 1093px) {
  .partner-list-page .pagenamPT {
    min-height: 30px;
    margin-bottom: 12px;
  }

  .partner-list-page .pagename2 {
    font-size: 18px;
  }
  .partner-list-page .pagenamPT + .partnerTop {
    min-height: 64px;
    margin-bottom: 14px;
    padding: 10px 14px;
  }
  .partner-list-page .pagenamPT + .partnerTop :deep(.datesearch.datePt) {
    min-height: 42px;
    margin: 0;
  }
  .partner-list-page .strTableWrap {
    gap: 14px;
  }
  .partner-list-page .partnerTreePc {
    flex-basis: 250px;
    width: 250px;
    min-width: 250px;
    padding: 14px;
  }
  .partner-list-page .w100 {
    min-width: 0;
  }
  .partner-list-page .strTablescr {
    margin-bottom: 14px;
    padding: 14px;
  }
  .partner-list-page .partnerInfo {
    gap: 14px;
  }
  .partner-list-page .infoView {
    gap: 12px;
  }
  .partner-list-page .partnerInfo ul {
    gap: 7px;
  }
  .partner-list-page .partnerInfo ul li {
    min-height: 62px;
  }
  .partner-list-page .partnerInfo ul li:first-child {
    min-height: 34px;
    padding: 0 12px;
  }
  .partner-list-page .partnerInfo ul li em {
    min-height: 27px;
    padding: 0 12px;
  }
  .partner-list-page .partnerInfo ul li span {
    min-height: 35px;
    padding: 0 12px;
  }
  .partner-list-page .partnerInfo + .partnerTop {
    min-height: 54px;
    margin: 0 0 14px;
    padding: 10px 14px;
  }
  .partner-list-page .partnerInfo + .partnerTop .title {
    margin: 0;
  }
  .partner-list-page .partnerInfo + .partnerTop .select {
    gap: 6px;
  }
  .partner-list-page .partnerInfo + .partnerTop .select a {
    height: 30px;
    padding: 0 12px;
  }
  .partner-list-page .partnerInfo + .partnerTop + .strTablescr {
    margin-bottom: 0;
  }
}
</style>
